export function updated_calendar_data(state = null, action) {
    switch (action.type) {
        case 'UPDATE_CALENDAR_DATA':
            return action.data;
        default:
            return state;
    }
}

export function updated_phone_mts_data(state = {}, action) {
    switch (action.type) {
        case 'UPDATE_PHONE_MTS_DATA':
            return action.data;
        default:
            return state;
    }
}

export function updated_phone_a1_data(state = {}, action) {
    switch (action.type) {
        case 'UPDATE_PHONE_A1_DATA':
            return action.data;
        default:
            return state;
    }
}

export function updated_contact_data(state = '', action) {
    switch (action.type) {
        case 'UPDATE_CONTACT_DATA':
            return action.text;
        default:
            return state;
    }
}

export function updated_work_data(state = '', action) {
    switch (action.type) {
        case 'UPDATE_WORK_DATA':
            return action.text;
        default:
            return state;
    }
}